export enum ProductManufacturerType {
  Manufacturer = 1,
  Importer = 2
}

(ProductManufacturerType as any).__typeName = 'ProductManufacturerType';
